import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { useStores } from "../../../../hooks";
import { Helmet } from "react-helmet";
import { Grid } from "@material-ui/core";
import { Divider, Typography } from "../../../../common/components/libs";
import Actions from "./components/Actions";

import PageStoreContext from "./context";
import TopCategories from "./components/TopCategories";
import TopItems from "./components/TopItems";
import GeneralStatsBlock from "./components/GeneralStatsBlock";
import {useTranslation} from "react-i18next";

const StatisticsPage = () => {
    const {i18n, t, ready} = useTranslation(["general", "stats"], { useSuspense: false });
    const { generalStore } = useStores();
    const pageStore = useContext(PageStoreContext);


    useEffect(() => {
        generalStore.setPageTitle(t("stats:statistics"));
        pageStore.init();
    }, [generalStore, pageStore, ready]);

    return <>
        <Helmet title={t("stats:ordersStatistics")}/>
        <Grid justify="space-between" alignItems='center' container spacing={6}>
            <Grid item>
                <Typography variant="h3">
                    {t("stats:ordersStatistics")}
                </Typography>
               {/* <Typography variant="body2" ml={2}>
                    {`Monday, 29 April ${new Date().getFullYear()}`}
                </Typography>*/}
            </Grid>

            <Grid item>
                <Actions/>
            </Grid>
        </Grid>

        <Divider my={6}/>
        <GeneralStatsBlock/>
        <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TopCategories/>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TopItems/>
            </Grid>
        </Grid>
    </>
};


export default observer(StatisticsPage);
